export default "__VITE_ASSET__7K1dIOpo__"